// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__OZVmN","content":"GlobalSearch_content__37is1"};